export default "__VITE_ASSET__CyxJt8ca__"